import {useLocalStorageDate} from '../../common/hooks/useLocalStorageDate';
import {UseStorageResult} from '../../common/hooks/useStorage';

export function useLastAccessTime(): UseStorageResult<Date> {
  return useLocalStorageDate('lastAccessTime');
}
